import type { Recommendation } from "./recommendation.type";

export const isRecommendationAssociatedWithManySections = (
  recommendation: Recommendation
) => {
  return recommendation?.observations?.length
    ? recommendation.observations.length > 1
    : false;
};
